import React, { useEffect, useState } from "react";
import {
  DialogMode,
  InfoDialog,
} from "components/shared-ui/dialogs/common/info-dialog/info-dialog";
import { healthCheckService } from "api/services/health-check-service";
import { IHealthcheck } from "api/entities/healthcheck";
import { useApi } from "utils/hooks/use-api";
import { Label } from "components/shared-ui/label";
import version from "version.json";
import styles from "./help-dialog.module.scss";

export interface IHelpDialogProps {
  open: boolean;
  onClose: () => void;
}

export function HelpDialog(props: IHelpDialogProps) {
  const [api, isLoading] = useApi();
  const [healthcheck, setHealthcheck] = useState<IHealthcheck | null>(null);
  const [error, setError] = useState<string>("");

  useEffect(() => {
    if (props.open) {
      setError("");
      fetchHealthcheck();
    }
  }, [props.open]);

  const fetchHealthcheck = async () => {
    try {
      const data = await api(healthCheckService.getHealthcheck());
      setHealthcheck(data);
    } catch (err) {
      setError("Failed to load system information");
      console.error("Healthcheck error:", err);
    }
  };

  return (
    <InfoDialog
      open={props.open}
      onClose={props.onClose}
      title="System Information"
      showOkButton
      testId="help-dialog"
    >
      {error && <div className={styles.error}>{error}</div>}

      {isLoading && (
        <div className={styles.loading}>Loading system information...</div>
      )}

      {healthcheck && (
        <>
          <section className={styles.section}>
            <h3 className={styles.sectionTitle}>Endpoint URLs</h3>
            <div className={styles.sectionContent}>
              <Label label="S3:" horizontal value={healthcheck.network.bzs} />
              <Label label="IAM:" horizontal value={healthcheck.network.iam} />
              <Label label="STS:" horizontal value={healthcheck.network.sts} />
            </div>
          </section>

          <section className={styles.section}>
            <h3 className={styles.sectionTitle}>API Version</h3>
            <div className={styles.sectionContent}>
              <Label label="Version:" horizontal value={healthcheck.semver} />
              <Label
                label="Build:"
                horizontal
                value={`${healthcheck.buildTime}.${healthcheck.hash}`}
              />
            </div>
          </section>

          <section className={styles.section}>
            <h3 className={styles.sectionTitle}>UI Version</h3>
            <div className={styles.sectionContent}>
              <Label
                label="Version:"
                horizontal
                value={version?.version}
              />

              <Label label="Build:" horizontal value={`${version?.date}.${version.commit}` } />
            </div>
          </section>
        </>
      )}
    </InfoDialog>
  );
}
